import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Instagram, Facebook, Linkedin, ShieldCheck } from 'lucide-react';

const SOCIAL_LINKS = [
  { id: 'twitter', Icon: Twitter },
  { id: 'instagram', Icon: Instagram },
  { id: 'facebook', Icon: Facebook },
  { id: 'linkedin', Icon: Linkedin },
];
const PRODUCT_LINKS = ['Cagnotte Joyeuse', 'Cagnotte Yako', 'Le Mur', 'Ambassadeurs', 'Saisons'];
const COMPANY_LINKS = ['À propos', 'Cercles B2B', 'Bourses', 'Foundations Pro', 'Crisis'];
const HELP_LINKS = ['Comment ça marche', 'Sécurité', { label: 'Frais', to: '/tarifs' }, { label: 'Centre d\'aide', to: '/contact' }, { label: 'Contact', to: '/contact' }];
const LEGAL_LINKS = [
  { label: 'Charte RGPD', to: '/rgpd' },
  { label: 'Conditions (CGU)', to: '/cgu' },
  { label: 'Confidentialité', to: '/rgpd' },
  { label: 'Cookies', to: '/rgpd' },
  { label: 'Mentions légales', to: '/cgu' },
];
const CONTACT_EMAILS = [
  'contact@fodindincagnotte.com',
  'marketing@fodindincagnotte.com',
  'support@fodindincagnotte.com',
  'securite@fodindincagnotte.com',
];

export default function Footer() {
  return (
    <footer className="bg-[#1a1d1a] text-[#e7f3e6]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2">
              <div className="w-9 h-9 rounded-lg bg-white text-[#1a1d1a] flex items-center justify-center font-bold">F</div>
              <div>
                <div className="text-[17px] font-semibold">Fodindin</div>
                <div className="text-[10px] tracking-[0.18em] uppercase text-white/50 mt-0.5">Solidarité</div>
              </div>
            </div>
            <p className="mt-5 text-[14px] text-white/70 max-w-sm leading-relaxed">
              La générosité et la solidarité en mouvement, en FCFA, partout en Afrique et dans la diaspora.
            </p>
            <Link
              to="/rgpd"
              data-testid="footer-rgpd-link"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 px-3.5 py-1.5 text-[12px] text-white/85 hover:text-white transition-colors"
            >
              <ShieldCheck className="w-3.5 h-3.5 text-[#5a8268]" /> Conforme RGPD · Loi 2016‑13 CI · UEMOA
            </Link>
            <div className="mt-5 flex gap-2">
              {SOCIAL_LINKS.map(({ id, Icon }) => (
                <a key={id} href="#social" aria-label={id} className="w-9 h-9 rounded-full bg-white/5 hover:bg-white/15 border border-white/10 flex items-center justify-center transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
            <div className="mt-6" data-testid="footer-emails">
              <div className="text-[11px] uppercase tracking-wider font-semibold text-white/50">Nous écrire</div>
              <ul className="mt-2 space-y-1 text-[12px]">
                {CONTACT_EMAILS.map((e) => (
                  <li key={e}><a href={`mailto:${e}`} className="text-white/55 hover:text-white transition-colors font-mono">{e}</a></li>
                ))}
              </ul>
            </div>
          </div>
          <FooterCol title="Produit" links={PRODUCT_LINKS} />
          <FooterCol title="Entreprise" links={COMPANY_LINKS} />
          <FooterCol title="Aide" links={HELP_LINKS} />
          <FooterCol title="Légal" links={LEGAL_LINKS} />
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-4 sm:items-center justify-between text-[12.5px] text-white/55">
          <div>© {new Date().getFullYear()} fodindincagnotte.com — Tous droits réservés.</div>
          <div>Fait avec ❤️ pour l'Afrique et la diaspora.</div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="md:col-span-2">
      <div className="text-[12px] uppercase tracking-wider font-semibold text-white/80">{title}</div>
      <ul className="mt-4 space-y-2 text-[13.5px]">
        {links.map((l) => {
          const key = typeof l === 'string' ? l : l.label;
          const label = typeof l === 'string' ? l : l.label;
          if (typeof l !== 'string' && l.to) {
            return <li key={key}><Link to={l.to} className="text-white/60 hover:text-white transition-colors">{label}</Link></li>;
          }
          const href = typeof l === 'string' ? '#x' : (l.href || '#x');
          return <li key={key}><a href={href} className="text-white/60 hover:text-white transition-colors">{label}</a></li>;
        })}
      </ul>
    </div>
  );
}
